import { useParams } from 'react-router-dom';
import { useAuthSlice } from 'src/store-redux/auth/auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';
import { ReadingCompletedLayout } from '@components/ReadingCompleted/ReadingCompletedLayout';

const ReadingCompleted = () => {
  const { clinicalTrialId } = useParams<{ clinicalTrialId: string }>();
  const userData = useAuthSlice(s => s.data);

  const userRole = userData?.selectedRole || UserRoles.EXTERNAL_USER;

  if (!clinicalTrialId) {
    return null;
  }

  return (
    <ReadingCompletedLayout
      clinicalTrialId={clinicalTrialId}
      listName='externalUserReadingCompleted'
      userRole={userRole}
    />
  );
};

export default ReadingCompleted;
